import * as React from "react";
import Spinner from "../../utils/Spinner";
import { Container, TextContainer } from "./CourseCompletionAnaltyics.styles";
import { ICourseCompletionAnalyticsProps } from "./CourseCompletionAnalytics.types";

export class CourseCompletionAnalytics extends React.Component<ICourseCompletionAnalyticsProps> {
  public componentDidMount() {
    this.props.loadAnalytics();
  }

  public render() {
    const {
      loading,
      analytics: { completed, completedUsers, notStarted, notStartedUsers, started, startedUsers, totalUsers },
    } = this.props;
    if (loading) {
      return (
        <Container>
          <Spinner fontSizeModifier={7.5} />
        </Container>
      );
    }
    return (
      <Container>
        <TextContainer>
          <strong>
            <em>Course completion</em>
          </strong>
        </TextContainer>
        <TextContainer>
          <span>
            <strong>Completed: </strong>
            {completedUsers} / {completed}%
          </span>
        </TextContainer>
        <TextContainer>
          <span>
            <strong>In Progress: </strong>
            {startedUsers} / {started}%
          </span>
        </TextContainer>
        <TextContainer>
          <span>
            <strong>Not Started: </strong>
            {notStartedUsers} / {notStarted}%
          </span>
        </TextContainer>
        <TextContainer>
          <span>
            <strong>All Users: </strong>
            {totalUsers}
          </span>
        </TextContainer>
      </Container>
    );
  }
}
